<template>
  <div>
    <div class="content">
      <v-app>
        <v-content>
          <v-container>
            <div>
              <div class="my-4 text-h4 mx-2">{{ name }} 隐私政策</div>

              <div style="padding: 10px 0 10px 25px">
                <div>
                  政策发布时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2026-08-05
                </div>
                <div>
                  最近更新时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2026-09-11
                </div>
                <div>更新版本生效时间：&nbsp;&nbsp;2026-09-11</div>
              </div>

              <div style="height: 20px"></div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                欢迎您访问我们的产品。
                <strong>{{ name }}</strong>（包括手机APP、网站、小程序等产品提供的服务，以下简称“产品和服务”）是由
                <strong>湖南大湘速聘信息科技有限公司</strong>（以下简称“我们”）开发并运营的。
                确保用户的数据安全和隐私保护是我们的首要任务，
                本隐私政策载明了您访问和使用我们的产品和服务时所收集的数据及其处理方式。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                请您在继续使用我们的产品前务必认真仔细阅读并确认充分理解本隐私政策全部规则和要点，
                一旦您选择使用，即视为您同意本隐私政策的全部内容，同意我们按其收集和使用您的相关信息。
                如在阅读过程中对本政策有任何疑问，可联系我们的客服咨询，请通过
                <strong>{{ email }}</strong> 或产品中的反馈方式与我们取得联系。
                如您不同意相关协议或其中的任何条款，您应停止使用我们的产品和服务。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                本隐私政策帮助您了解以下内容：
                <div class="mt-2">一、定义；</div>
                <div>二、我们如何收集和使用您的个人信息；</div>
                <div>三、我们如何存储和保护您的个人信息；</div>
                <div>四、我们如何共享、转让、公开披露您的个人信息；</div>
                <div>五、权限调用说明；</div>
                <div>六、第三方 SDK 与信息共享说明（含第三方 SDK 采集频率说明）；</div>
                <div>七、您的个人信息权利及行使方式；</div>
                <div>八、本政策如何更新；</div>
                <div>九、如何联系我们。</div>
              </div>

              <!-- 一、定义 -->
              <div class="text-h6 mb-4">一、定义</div>

              <div class="text-muted" style="text-indent: 2em">
                <strong>我们：</strong>指湖南大湘速聘信息科技有限公司。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人信息：</strong>指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>个人敏感信息：</strong>指一旦泄露或者非法使用，可能导致个人受到歧视或者人身、财产受到严重危害的个人信息，包括种族、民族、宗教信仰、个人生物特征、医疗健康、金融账户、个人行踪等信息（本政策中对具体个人敏感信息以<strong>粗体</strong>进行显著标识）。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>第三方 SDK：</strong>指由第三方服务商提供、内置于本产品中，用于实现消息推送等特定功能的软件开发工具包。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>静默状态或后台运行：</strong>指您未在前台使用本产品，但本产品进程或推送服务仍在运行的状态，此时我们及第三方 SDK 仅为维持消息推送通道与接收消息而处理必要信息。
              </div>
              <div class="text-muted" style="text-indent: 2em">
                <strong>未成年人：</strong>指不满十八周岁的自然人。
              </div>
              <div class="text-muted mb-4" style="text-indent: 2em">
                <strong>儿童：</strong>指不满十四周岁的自然人。
              </div>

              <!-- 二、收集和使用 -->
              <div class="text-h6 mb-4">二、我们如何收集和使用您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们根据《中华人民共和国网络安全法》《中华人民共和国个人信息保护法》和《信息安全技术 个人信息安全规范》（GB/T
                35273-2020）以及其他相关法律法规的要求，严格遵循正当、合法、必要的原则，
                出于为您提供产品和服务的需要收集和使用您的个人信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为接受我们全面的产品服务，您应首先注册一个用户账号。您所提供的账户名、密码、联系方式等信息，
                将在注册过程中由您主动提交。我们可能通过发送短信或邮件的方式验证您的身份是否有效。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们会在您首次启动本产品时，以弹窗形式向您展示本政策，<strong>仅在您主动点击“同意”后</strong>，
                才会启动消息推送服务及其对应的第三方 SDK；若您点击“不同意”，我们不会初始化任何第三方 SDK，
                也不会收集任何个人信息。
              </div>

              <!-- 三、存储和保护 -->
              <div class="text-h6 mb-4">三、我们如何存储和保护您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                作为一般规则，我们仅在实现信息收集目的所需的时间内保留您的个人信息。
                出于管理与您之间关系的必要，我们会保留账户及相关业务数据。
                如需遵守法律义务或满足法定时效要求，我们可能在上述期限到期后继续留存相关信息，并依法采取安全保护措施。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为加强对隐私数据的保护，我们在收集时对敏感信息进行脱敏处理，
                在我们的生产环境中原则上不会存储可还原的明文隐私数据。
              </div>

              <!-- 四、共享、转让、公开披露 -->
              <div class="text-h6 mb-4">四、我们如何共享、转让、公开披露您的个人信息</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                除本政策及法律法规另有规定外，我们不会主动向第三方共享您的个人信息。
                仅在合法合规前提下，根据政府主管部门的强制性要求（如传票、调查函等）提供相关信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为实现消息推送功能，本产品接入了第三方推送 SDK 及其手机厂商推送通道，
                在您同意本政策后，上述 SDK 会按“<strong>六、第三方 SDK 与信息共享说明</strong>”所述的目的、方式和范围处理相关信息，
                具体清单及各自的隐私政策链接详见第六条。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                在以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
                <div class="mt-2">
                  1、与国家安全、国防安全直接相关的；<br />
                  2、与犯罪侦查、起诉、审判和判决执行等直接相关的；<br />
                  3、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；<br />
                  4、您自行向社会公众公开的个人信息；<br />
                  5、从合法公开披露的信息中收集的个人信息；<br />
                  6、根据个人信息主体要求签订和履行合同所必需的；<br />
                  7、用于维护产品或服务安全稳定运行所必需的，如发现、处置故障；<br />
                  8、法律法规规定的其他情形。
                </div>
              </div>

              <!-- 五、权限调用 -->
              <div class="text-h6 mb-4">五、权限调用说明</div>

              <ul style="padding:0 0 0 20px" class="text-muted">
                <li>
                  <strong>相机权限</strong>：在您使用拍照、扫码等功能时，经您授权后调用。
                </li>
                <li>
                  <strong>相册/媒体权限</strong>：在您上传或保存图片（如证件照、档案材料）时，经您授权后调用。
                </li>
                <li>
                  <strong>存储权限</strong>：用于在拍摄、裁剪、上传图片或安装应用更新包时读写本地文件，仅在相关功能使用时调用。
                </li>
                <li>
                  <strong>蓝牙权限</strong>：在您连接蓝牙设备时，经您授权后调用。
                </li>
                <li>
                  <strong>位置权限</strong>：在您使用需要定位的功能时，经您授权后调用；<strong>我们不会在后台持续获取您的位置</strong>。
                </li>
                <li>
                  <strong>通知权限</strong>：用于向您发送面试、入职进度等业务消息提醒；您可在系统设置中随时关闭，关闭后不影响其他功能使用。
                </li>
                <li>
                  <strong>应用安装与版本更新权限</strong>：用于检测并安装本产品的新版本安装包。
                </li>
                <li>
                  <strong>自启动与关联启动</strong>：为提升消息送达率，推送服务可能在系统允许时自启动或关联启动，以保持推送长连接；
                  您可在系统“设置 - 应用 - 应用启动管理”中关闭该能力，关闭后可能延迟收到消息。
                </li>

                <li>
                  <strong>传感器权限</strong>：为提升服务稳定性与用户体验，在经您授权后，我们可能会调用设备中的部分传感器：
                  <ul style="padding-left: 20px;">
                    <li>
                      <strong>加速度传感器 / 陀螺仪</strong>：
                      用于识别设备运动状态，优化推送链路稳定性、页面交互体验及异常行为风控。
                    </li>
                    <li>
                      <strong>距离（接近）传感器</strong>：
                      在特定交互场景下自动关闭屏幕或调整界面展示。
                    </li>
                    <li>
                      <strong>光线传感器</strong>：
                      根据环境亮度自适应调整界面显示效果。
                    </li>
                  </ul>
                  上述传感器数据仅在设备本地处理，不会用于用户画像或广告推荐，也不会上传至服务器。
                </li>

                <li>
                  <strong>应用检测更新说明</strong>：为向您提供最新版本，我们会在后台检测更新并提醒您升级。
                </li>
              </ul>

              <div class="text-muted mb-4" style="text-indent: 2em">
                以上权限均为可选授权，您可以在系统设置中随时开启或关闭；
                关闭某项权限仅会导致对应功能不可用，不影响其他功能的正常使用。
              </div>

              <!-- 六、第三方 SDK -->
              <div class="text-h6 mb-4">六、第三方 SDK 与信息共享说明</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为向您提供稳定可靠的消息推送服务，本产品接入了极光推送 SDK 及其手机厂商推送通道。
                我们已逐一列出第三方 SDK 的名称、提供方、处理个人信息的种类与目的、采集方式、
                收集频率与时机、隐私政策链接等信息，具体如下。
                <strong>在您同意本政策之前，我们不会初始化上述 SDK，也不会通过其收集任何个人信息。</strong>
              </div>

              <!-- 6.1 极光推送 -->
              <p class="text-muted"><strong>（一）极光推送 SDK（JPush / JCore）</strong></p>

              <table
                style="width:100%; border-collapse:collapse; font-size:13px; color:rgba(0,0,0,0.6); margin-bottom:16px"
              >
                <tbody>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; width:26%; background:#fafafa">
                      SDK 名称
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      极光推送 SDK（JPush / JCore）
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      第三方主体
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      深圳市和讯华谷信息技术有限公司
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      使用目的
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      为 App 用户提供消息与通知推送服务，实现面试、入职进度等业务消息的准确送达
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      处理个人信息种类
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      1、设备标识符：<strong>Android ID</strong>、GAID、OAID、UAID、AAID、IDFA、Boot ID；
                      2、设备硬件信息：设备型号、屏幕分辨率、设备硬件制造商、设备产品名称、存储空间；
                      3、操作系统信息：操作系统版本、系统名称、系统语言；
                      4、网络信息：网络类型、运营商信息、IP 地址、DHCP、WIFI 状态信息；
                      5、推送信息日志：用于查询推送服务记录、了解消息送达情况。
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      采集方式
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      由 SDK 在 App 运行过程中自动采集（通过系统接口读取设备标识与网络状态），
                      无需您手动填写；我们不会在后台额外下发采集指令
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      收集频率与时机
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      仅在您启动 App、使用消息推送功能时触发，即：App 启动并建立推送长连接、
                      长连接保活与重新连接、消息下发与接收、推送消息送达与点击状态上报等与推送直接相关的时机读取。
                      <strong>App 在静默状态或后台运行时，仅为维持推送通道、接收消息而按实现推送服务所必需的最低频率读取，不进行周期性、无关场景的采集，
                      也不会因 App 使用时长增加而提高频率</strong>。该频率由推送服务实现所决定，我们无法自行配置或要求其提高。
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      数据处理方式
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      通过去标识化、加密传输及其他安全方式处理
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      官网
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a href="https://www.jiguang.cn/" target="_blank">https://www.jiguang.cn/</a>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px; background:#fafafa">
                      隐私政策
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a href="https://www.jiguang.cn/license/privacy" target="_blank">
                        《AURORA 极光隐私政策》
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为落实最小必要原则，我们<strong>已关闭极光推送 SDK 的全部可选个人信息开关与扩展业务功能</strong>，
                包括但不限于：IMEI、MAC 地址、IMSI、SSID、BSSID、WiFi 列表信息、基站信息与 SIM 卡状态等信息，
                以及用户分群推送、地理围栏推送、应用自启动、链路调节器、用户洞察、应用活跃时长统计等扩展功能。
                因此，上述 SDK <strong>不会收集软件安装列表、精确位置信息、蓝牙信息及上述可选设备标识信息</strong>。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                App 在静默状态或后台运行时，极光推送 SDK 仅处理为维持推送通道与接收消息所必需的最少信息
                （设备标识符、设备与操作系统信息、网络信息、推送信息日志），
                不会在后台收集您的位置、通讯录、通话记录、短信、日历、本机电话号码、图片、音视频等信息，
                也不会将上述信息用于推送服务之外的任何目的。
              </div>

              <!-- 6.2 厂商通道 -->
              <p class="text-muted">
                <strong>（二）手机厂商推送通道 SDK</strong>
              </p>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为提升消息送达率，极光推送 SDK 会在对应品牌的手机终端上调用系统级推送通道，
                该通道<strong>仅在相应品牌手机终端推送消息时使用</strong>，具体如下：
              </div>

              <table
                style="width:100%; border-collapse:collapse; font-size:13px; color:rgba(0,0,0,0.6); margin-bottom:16px"
              >
                <thead>
                  <tr>
                    <th style="border:1px solid #e0e0e0; padding:8px; text-align:left; background:#fafafa">
                      SDK 名称
                    </th>
                    <th style="border:1px solid #e0e0e0; padding:8px; text-align:left; background:#fafafa">
                      第三方主体
                    </th>
                    <th style="border:1px solid #e0e0e0; padding:8px; text-align:left; background:#fafafa">
                      涉及的个人信息类型
                    </th>
                    <th style="border:1px solid #e0e0e0; padding:8px; text-align:left; background:#fafafa">
                      使用目的
                    </th>
                    <th style="border:1px solid #e0e0e0; padding:8px; text-align:left; background:#fafafa">
                      隐私政策
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px">OPPO 推送 SDK</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">广东欢太科技有限公司</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      应用基本信息（MCS 应用包名、应用版本号、OPUSH SDK 版本号）、应用内设备标识符（RegisterID、appKey、appSecret）
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      在 OPPO 手机终端推送消息时使用
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a
                        href="https://open.oppomobile.com/new/developmentDoc/info?id=11228"
                        target="_blank"
                      >
                        https://open.oppomobile.com/new/developmentDoc/info?id=11228
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px">华为推送 SDK（HMS）</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">华为软件技术有限公司</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      应用信息、设备信息（设备的硬件信息、系统基本信息和系统设置）
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      在华为手机终端推送消息时使用
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a
                        href="https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177"
                        target="_blank"
                      >
                        https://developer.huawei.com/consumer/cn/doc/development/HMSCore-Guides/sdk-data-security-0000001050042177
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px">小米推送 SDK</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">北京小米移动软件有限公司</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      设备标识（OAID、加密的 Android ID）、推送消息内容、设备信息（设备厂商、型号、归属地、运营商名称等）、通知栏设置
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      在小米手机终端推送消息时使用
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a href="https://dev.mi.com/console/doc/detail?pId=1822" target="_blank">
                        https://dev.mi.com/console/doc/detail?pId=1822
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px">vivo 推送 SDK</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">维沃移动通信有限公司</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      应用基本信息、应用内设备标识符、设备的硬件信息、系统基本信息
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      在 vivo 手机终端推送消息时使用
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a href="https://dev.vivo.com.cn/documentCenter/doc/652" target="_blank">
                        https://dev.vivo.com.cn/documentCenter/doc/652
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td style="border:1px solid #e0e0e0; padding:8px">荣耀推送 SDK</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">深圳荣耀软件技术有限公司</td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      应用匿名标识（AAID）、应用 Token（PushToken）、OAID、APPID、应用包名
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      在荣耀手机终端推送消息时使用
                    </td>
                    <td style="border:1px solid #e0e0e0; padding:8px">
                      <a
                        href="https://developer.honor.com/cn/docs/11002/guides/sdk-data-security"
                        target="_blank"
                      >
                        https://developer.honor.com/cn/docs/11002/guides/sdk-data-security
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- 6.3 频率与后台说明 -->
              <p class="text-muted"><strong>（三）第三方 SDK 在静默或后台状态下的收集频率说明</strong></p>

              <div class="text-muted mb-4" style="text-indent: 2em">
                1、上述第三方 SDK 的采集行为<strong>仅在您使用本产品相关功能时触发</strong>：
                您启动 App 并启用推送服务、推送长连接建立与保活、消息下发与接收、消息送达与点击状态上报等时机，
                SDK 会读取必要的设备标识与网络状态信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                2、App 处于<strong>静默状态或后台运行</strong>时，第三方 SDK 仅在为维持推送通道、接收离线消息所必需的最低频率下读取上述必要信息，
                不会进行周期性轮询式采集，不会因 App 使用时长、使用频次而提高采集频率，
                也不会在后台收集位置、通讯录、通话记录、短信、日历、本机电话号码、图片、音视频等信息。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                3、上述采集频率由推送服务的实现机制决定，<strong>我们无法自行配置或要求 SDK 提高频率</strong>；
                我们已关闭全部可选信息与扩展功能，将其降低到实现消息推送所必需的最低频率。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                4、您随时可以通过本政策第七条所述方式撤回同意、关闭推送或注销账号；
                撤回同意或关闭推送后，我们将停止上述 SDK 的推送业务功能，不再进行相关信息的采集与处理。
              </div>

              <!-- 6.4 关闭方式 -->
              <p class="text-muted"><strong>（四）如何关闭推送或第三方 SDK 采集</strong></p>
              <ul style="padding:0 0 0 20px" class="text-muted">
                <li>在手机“设置 - 通知管理”中关闭本产品的通知权限，即可停止接收推送消息；</li>
                <li>在手机“设置 - 应用 - 应用启动管理”中关闭本产品的自启动与关联启动，可减少后台运行；</li>
                <li>在“我的 - 设置”中关闭消息推送开关（如产品提供），或通过本政策第九条的联系方式联系我们协助关闭；</li>
                <li>您也可以通过注销账号的方式停止全部个人信息的处理（详见第七条）。</li>
              </ul>

              <!-- 七、您的权利 -->
              <div class="text-h6 mb-4">七、您的个人信息权利及行使方式</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                按照相关法律法规的规定，您对您的个人信息享有以下权利：
                <div class="mt-2">
                  1、<strong>查阅、复制权</strong>：您可以在产品内相关页面查阅您的账户信息、业务信息，并可申请获取个人信息副本；<br />
                  2、<strong>更正、补充权</strong>：如您发现我们处理的您的个人信息不准确或不完整，可要求我们更正、补充；<br />
                  3、<strong>删除权</strong>：在法定情形下，您可要求我们删除您的个人信息；<br />
                  4、<strong>撤回同意权</strong>：您可随时撤回对本政策的同意（如关闭推送、关闭相应权限），
                  撤回同意不影响撤回前基于您的同意已进行的个人信息处理活动的效力；<br />
                  5、<strong>注销账号权</strong>：您可以通过产品内“注销账号”入口或本政策第九条的联系方式申请注销，
                  注销后我们将停止为您提供服务并删除或匿名化您的个人信息，法律法规另有规定的除外；<br />
                  6、<strong>个性化推送管理权</strong>：如您不希望接收推送消息，可通过第六条（四）所述方式关闭；<br />
                  7、<strong>投诉举报权</strong>：您可通过本政策第九条的联系方式投诉举报，或向网信、市场监管、公安等监管部门反映。
                </div>
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                为保障安全，我们可能需要您提供书面请求或验证您的身份后再处理您的请求，
                我们将在收到您的请求后 30 天内予以回复。
              </div>

              <!-- 八、政策更新 -->
              <div class="text-h6 mb-4">八、本政策如何更新</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的隐私政策可能适时变更。未经您明确同意，我们不会削减您在本政策项下应享有的权利。
                本政策更新后，我们将在本页面发布最新版本，并在发生重大变更时通过站内通知、弹窗、短信或邮件等方式告知您。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                本政策所指的重大变更包括但不限于：
                <div class="mt-2">
                  1、服务模式发生重大变化；<br />
                  2、公司组织结构或所有权发生变更；<br />
                  3、个人信息共享、转让或公开披露的对象发生变化（含新增或变更第三方 SDK）；<br />
                  4、您行使个人信息权利的方式发生重大变化；<br />
                  5、个人信息保护负责人或投诉渠道发生变化；<br />
                  6、经安全评估表明存在高风险的其他情形。
                </div>
              </div>

              <!-- 九、联系我们 -->
              <div class="text-h6 mb-4">九、如何联系我们</div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                如您对本政策有任何疑问、意见或建议，可通过以下方式联系我们：
                <div class="mt-2">
                  （1）电子邮件：{{ email }}<br />
                  （2）联系地址：湖南省长沙市岳麓区望城坡街道枫林三路49号换乘大楼101一楼南侧105，联系人：前台
                </div>
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                我们的客服及个人信息保护专职部门将在收到您请求后的 30 天内予以回复并处理。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">
                如您对我们的处理结果不满意，可向湖南大湘速聘信息科技有限公司所在地人民法院提起诉讼，
                或向网信、市场监管、公安等监管部门投诉举报。
              </div>

              <div class="text-muted mb-4" style="text-indent: 2em">（完）</div>
            </div>
          </v-container>
        </v-content>
      </v-app>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "",
      email: "admin@daxiangsys.com"
    };
  },
  mounted() {
    const query = this.$route.query;
    this.name = query.name || "大象系统";
  }
};
</script>

<style scoped>
.content {
  padding: 20px;
}
.text-muted {
  color: rgba(0, 0, 0, 0.6);
}
table td,
table th {
  word-break: break-all;
}
</style>
